import {
  createContext,
  useCallback,
  useContext,
  useMemo,
  useState
} from "react";

import setupLocalStorageAPI from "utils/setupLocalStorageAPI";

// Blurs a value while Privacy Mode is on: the text stays in the layout (no
// column shift) but can't be read over the user's shoulder.
export const PRIVATE_MODE_SX = {
  color: "transparent",
  textShadow: "0 0 14px #000"
};

const PrivacyModeContext = createContext({
  isPrivateMode: false,
  handlePrivacyModeChange: () => {}
});

export const PrivacyModeProvider = ({ children }: any) => {
  const privacyModeStorage = useMemo(
    () => setupLocalStorageAPI("privacyMode"),
    []
  );
  const [isPrivateMode, setIsPrivateMode] = useState(
    privacyModeStorage.getData(false)
  );

  const handlePrivacyModeChange = useCallback(() => {
    setIsPrivateMode((prevValue: boolean) => !prevValue);
    privacyModeStorage.updateData(!isPrivateMode);
  }, [privacyModeStorage, isPrivateMode]);

  const value = useMemo(
    () => ({ isPrivateMode, handlePrivacyModeChange }),
    [isPrivateMode, handlePrivacyModeChange]
  );

  return (
    <PrivacyModeContext.Provider value={value}>
      {children}
    </PrivacyModeContext.Provider>
  );
};

export const usePatientPrivacy = () => {
  const context = useContext(PrivacyModeContext);
  if (!context) {
    throw new Error(
      `usePatientPrivacy must be used within a PrivacyModeProvider`
    );
  }
  const { isPrivateMode, handlePrivacyModeChange } = context;
  return {
    isPrivateMode,
    handlePrivacyModeChange
  };
};
